import { AxiosResponse } from 'axios';
import { all, call, CallEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';
import { BarcodeSearch } from 'b2b-apps/shop/catalog/api/BarcodeSearch';
import {
  fetchBarcodeSearchFulfilled,
  fetchBarcodeSearchRejected,
} from 'b2b-apps/shop/catalog/redux/barcodeSearch/actionCreators';
import { FETCH_BARCODE_SEARCH } from 'b2b-apps/shop/catalog/redux/barcodeSearch/actionTypes';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { BarcodeSearchType, FetchBarcodeSearchAction } from 'b2b-common/core/catalog/api/BarcodeSearchTypes';

function* fetchBarcodeSearchSaga(
  action: FetchBarcodeSearchAction,
): Generator<CallEffect | PutEffect, void, AxiosResponse<BarcodeSearchType>> {
  const { barcode } = action.payload;

  try {
    const response = yield call(requestApiSaga, BarcodeSearch.fetch(barcode));
    yield put(fetchBarcodeSearchFulfilled(barcode, response.data));
  } catch (error) {
    yield put(fetchBarcodeSearchRejected(barcode, parseError(error)));
    yield put(reportError(action.type, error, action.payload));
  }
}

function* barcodeSearchSaga(): Generator<any, any, any> {
  yield all([takeLatest(FETCH_BARCODE_SEARCH, fetchBarcodeSearchSaga)]);
}

export { barcodeSearchSaga };
